export const hasContactDeletePermissions = (email, contactPermissions) => {
  const contactPermission = contactPermissions && contactPermissions.get(email);
  return Boolean(contactPermission && contactPermission.canDelete);
};